import {examActions} from './ExamAction';

const initState = {
    loadingFlags: {
        
    },
    errors: {
        
    },
    title: null,
    date: null,
    endTime: null,
    question: {
        title: '',
        choices: []
    },
    duration: null,
    currentQuestion: null,
    totalQuestion: null,
    status: null,
    selectedChoice: null,
}

export default function programPageReducer(state=initState, action) {
    switch (action.type) {
        case examActions.setError:
            return setError(state, action);
        case examActions.toggleSpinner:
            return toggleSpinner(state, action);
        case examActions.setExamData:
            return setExamData(state, action);
        case examActions.setQuestionState:
            return setQuestionState(state, action);
        case examActions.setQuestion:
            return setQuestion(state, action);
        case examActions.selectChoice:
            return selectChoice(state, action);
        case examActions.deSelectChoice:
            return deSelectChoice(state, action);
        default:
            return state;
    }
}

function deSelectChoice(state) {
    return {
        ...state,
        selectedChoice: null,
    }
}

function selectChoice(state, { payload }) {
    return {
        ...state,
        selectedChoice: payload,
    }
}

function setQuestion(state, { payload }) {
    return {
        ...state,
        question: {
            title: payload.title,
            description: payload.description,
            choices: payload.choices
        }
    }
}

function setQuestionState(state, { payload }) {
    return {
        ...state,
        currentQuestion: payload.currentQuestion,
        totalQuestion: payload.totalQuestion,
        status: payload.examStatus
    }
}

function setExamData(state, {payload}) {
    return {
        ...state,
        title: payload.title,
        date: payload.date,
        endTime: payload.endTime,
        duration: payload.duration,
    }
}

function setError(state, {payload, meta}) {
    return {
        ...state,
        errors: {
            ...state.errors,
            [meta.apiName]: payload 
        },
    }
}

function toggleSpinner(state, {payload, meta}) {
    return {
        ...state,
        loadingFlags: {
            ...state.loadingFlags,
            [meta.apiName]: payload
        },
    }
}